/**
 * Cart Reducer Helper Function
 */

import { environment } from '../../relay';
import { AddItemToCartMutation, DeleteItemFromCartMutation, UpdateCartItemTermsMutation } from '../../relay/cart';
import { licenseUsagesToSearchParams } from './license';

import { commitMutation } from 'react-relay';
import { RelayMutation } from '../../utils/relay';

export const addItemToCart = ({ lineItem, viewerId }: IAddItemToCartActionPayload) => {
  const input: GQL.IAddItemInput = {
    license_item: {
      track_id: lineItem.track.id!,
      usages: licenseUsagesToSearchParams(lineItem.terms),
    },
  };

  return new Promise<IMutationResult>((resolve, reject) => {
    commitMutation<RelayMutation<GQL.IAddItemInput>>(environment, {
      mutation: AddItemToCartMutation,
      variables: { input },
      updater: (storeProxy) => {
        const viewerRecord = storeProxy.get(viewerId)!;
        const record = storeProxy.getRootField('addItem');
        if (record) {
          const newCartRecord = record.getLinkedRecord('cart')!;
          viewerRecord.setLinkedRecord(newCartRecord, 'cart');
        }
      },
      onCompleted: (response, errors) => resolve({ response, errors }),
      onError: reject,
    });
  });
};

export const updateCartItemTerms = ({ lineItemId, terms }: IUpdateCartItemTermsActionPayload) => {
  const input: GQL.IUpdateItemInput = {
    license_item: {
      id: lineItemId,
      usages: licenseUsagesToSearchParams(terms),
    },
  };

  return new Promise<IMutationResult>((resolve, reject) => {
    commitMutation<RelayMutation<GQL.IUpdateItemInput>>(environment, {
      mutation: UpdateCartItemTermsMutation,
      variables: { input },
      onCompleted: (response, errors) => resolve({ response, errors }),
      onError: reject,
    });
  });
};

export const removeItemFromCart = ({ lineItem }: IRemoveItemFromCartActionPayload) => {
  const input: GQL.IDeleteItemInput = {
    id: lineItem.id,
  };
  return new Promise<IMutationResult>((resolve, reject) => {
    commitMutation<RelayMutation<GQL.IDeleteItemInput>>(environment, {
      mutation: DeleteItemFromCartMutation,
      variables: { input },
      onCompleted: (response, errors) => resolve({ response, errors }),
      onError: reject,
    });
  });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/helpers/cart.ts